<template>
  <v-card v-if="loading" class="control-card preload-box h-100 pa-2" style="min-height: 380px;">
    <v-progress-circular indeterminate color="primary" class="h-100"></v-progress-circular>
  </v-card>
  <div class="control-telegram" v-else>
    <v-card class="control-card" style="gap: 16px;">
      <div style="display: flex;">
        <div>
          <p class="control-card__title mb-1">Телеграммы</p>
          <span>За текущие сутки </span>
        </div>
        <div class=" grey--text ml-auto font-weight-bold" style="font-size: 36px;">{{ telegrams.in_tlg || '-' }}</div>
      </div>
      <div class="control-cards__colored">
        <div class="control-card__colored control-card__green ">
          <div>Разобрано успешно</div>
          <div class="green--text " style="font-size: 20px;">{{ telegrams.parsed_tlg || '-' }}</div>
        </div>
        <div class="control-card__colored control-card__orange ">
          <div>Разобрано с ошибкой</div>
          <div class="orange--text " style="font-size: 20px;">{{ telegrams.mistake_tlg || '-' }}</div>
        </div>
        <div class="control-card__colored control-card__red ">
          <div>Не разобрано</div>
          <div class="red--text " style="font-size: 20px;">{{ telegrams.notparsed_tlg || '-' }}</div>
        </div>
      </div>
      <div class="telegram-cards">
        <div v-for="card in telegramCards" class="telegram-cards__item" :key="card.name">
          <span>{{ card.name || '-' }}</span>
          <p>{{ card.value || '-' }}</p>
        </div>
      </div>
    </v-card>
    <v-card class="control-card">
      <p class="control-card__title">Слот координация</p>
      <v-layout mt-2 wrap style="gap: 16px;">
        <v-flex style="display: flex; gap: 8px; flex-direction: column; flex: 1;">
          <div>За текущий период <br> навигации</div>
          <div class="control-card__part control-card__telegram">
            <div>Получено <br>сообщений</div>
            <span class="grey--text ml-auto">{{ slots.current_in || '-' }}</span>
          </div>
          <div class="control-card__part control-card__telegram ">
            <div>Отправлено <br> ответов</div>
            <span class="blue--text ml-auto">{{ slots.current_out || '-' }}</span>
          </div>
          <div class="control-card__part control-card__telegram ">
            <div>Предложено <br> альтернатив</div>
            <span class="grey--text ml-auto">{{ slots.current_outalt || '-' }}</span>
          </div>
          <div class="control-card__part control-card__telegram ">
            <div>Альтернатив <br>на соглас-нии</div>
            <span class="blue--text ml-auto">{{ slots.current_waitalt || '-' }}</span>
          </div>
        </v-flex>
        <v-flex style="display: flex; gap: 8px; flex-direction: column; flex: 1;">
          <div>На предстоящий период <br> навигации</div>
          <div class="control-card__part control-card__telegram">
            <div>Получено <br>сообщений</div>
            <span class="grey--text ml-auto">{{ slots.future_in || '-' }}</span>
          </div>
          <div class="control-card__part control-card__telegram ">
            <div>Отправлено <br> ответов</div>
            <span class="blue--text ml-auto">{{ slots.future_out || '-' }}</span>
          </div>
          <div class="control-card__part control-card__telegram ">
            <div>Предложено <br> альтернатив</div>
            <span class="grey--text ml-auto">{{ slots.future_outalt || '-' }}</span>
          </div>
          <div class="control-card__part control-card__telegram ">
            <div>Альтернатив <br> на соглас-нии</div>
            <span class="blue--text ml-auto">{{ slots.future_waitalt || '-' }}</span>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import store from '@/store'
export default {
  props: ['loading'],
  data: () => ({
    selectedCompany: '',
    selectedAirport: ''
  }),
  computed: {
    controlsData() {
      return store.getters['controls/getControls']
    },
    telegrams() {
      return this.controlsData.telegrams || {}
    },
    slots() {
      return this.controlsData.slots || {}
    },
    telegramCards() {
      return this.controlsData.time_tlg || []
    }
  }
}
</script>
